import { HsMatrix4 } from '../../../math-new/objects/matrix4.class';
import { HsCamera } from './camera.class';

export class HsOrthographicCamera extends HsCamera {
  public width: number = 1;
  public height: number = 1;

  protected calculateProjectionMatrix(): void {
    const w: number = this.width / 2;
    const h: number = this.height / 2;
    this.projectionMatrix = HsMatrix4.makeOrthographicMatrix(-w, w, -h, h, this.near, this.far);
  }
}
